import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import BankStatementFields from './BankStatementFields'

export const BankStatementCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <BankStatementFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default BankStatementCreate
